import { CanvasTemplate } from "shared/datamodel/schemas/canvas-template";
import consts from "shared/consts";
import { LiveIntegrationFilter } from "./elements-toolbar/widgets/live-integration/utils";

export type SubmenuData = {
  pen: { color: string };
  stickyNote: { color: string };
  shape: {
    type: string;
    color: string;
    border: string;
    dash: number;
    subtype: string;
    scaleX: number;
    scaleY: number;
  };
  template: CanvasTemplate | null;
  connector: {
    lineType: "curve" | "line" | "elbow";
    startArrow: string;
    endArrow: string;
    dash: number;
    strokeWidth?: number;
    stroke?: string;
  };
  frame: {
    width: number | null;
    height: number | null;
    color?: string;
  };
  table: {
    rows: number;
    cols: number;
    style: {
      stroke: string;
      defaults: { fill: string };
      rules: Array<{ row?: number; col?: number; style: any }>;
    };
  };
  textBlock: {
    textColor?: string;
    fontSize?: number;
    font?: string;
    align?: string;
  };
  icon: {
    href?: string;
  };
  task: {
    color: string;
  };
  nounIcon: null | {
    id: string;
    thumbnail: string;
    icon_url?: string;
  };
  liveIntegration: {
    integrationId?: string;
    title?: string;
    filters?: LiveIntegrationFilter[];
  };
};

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[] ? DeepPartial<U>[] : T[P] extends object ? DeepPartial<T[P]> : T[P];
};
export type SubmenuDataUpdate = DeepPartial<SubmenuData>;

export const defaultSubmenuData = {
  pen: { color: consts.COLOR_PALETTE[0] },
  stickyNote: { color: consts.STICKY_NOTE_COLORS[1] },
  shape: {
    color: "white",
    border: consts.COLOR_PALETTE[0],
    type: "shape",
    subtype: "circle",
    dash: 0,
    scaleX: 1,
    scaleY: 1,
  },
  textBlock: {},
  icon: {
    href: "",
  },
  template: null,
  connector: {
    lineType: "curve",
    startArrow: "none",
    endArrow: "filled-rounded-arrow",
    dash: 0,
    // strokeWidth: not adding it because for CIM and standalone there is a different default, which is selected
    // when using this data. the atom that will be initialized with this data will still be updates by style changes anyway, so it's ok to leave it here undefined.
    // stroke: also left undefined for same reason
    // stroke: "#A6AAAD",
  },
  frame: {
    width: null,
    height: null,
    color: "#FFFFFF",
  },
  task: {
    color: "#FFFFFF",
  },
  table: {
    rows: 3,
    cols: 3,
    style: {
      stroke: "#C8C8C8",
      defaults: { fill: "#ffffff" },
      rules: [],
    },
  },
  nounIcon: null,
  liveIntegration: {},
} as SubmenuData;
